@let list = dataList();

@for (item of list; track item.id;) {
  <mir-wizard-panel-list-item
    [entity]="item"
    [editable]="editable()">
  </mir-wizard-panel-list-item>
}
